export default {
    MUST_EQUIP_AXE: 'Du musst eine Axt ausrüsten, um Bäume fällen zu können.',
    MUST_EQUIP_PICKAXE: 'Du musst eine Spitzhacke ausrüsten, um Steine abbauen zu können.',
    MUST_EQUIP_FISHING: 'Du musst ein Angelgerät ausrüsten, um fischen zu können.',
    MUST_EQUIP_FORAGING: 'Du brauchst ein spezielles Werkzeug, um dieses zu ernten',

    INVALID_LEVEL_LUMBERJACKING: 'Du musst Level {{level}} sein, um diesen Baum fällen zu können.',
    INVALID_LEVEL_MINING: 'Du musst Level {{level}} sein, um dieses Gestein abbauen zu können.',
    INVALID_LEVEL_FISHING: 'Du musst Level {{level}} sein, um hier angeln zu können.',
    INVALID_LEVEL_FORAGING: 'Du musst Level {{level}} sein, um diese Ressource ernten zu können.',

    UNABLE_TO_INTERACT_LUMBERJACKING: 'Du kannst diesen Baum im Moment nicht fällen.',
    UNABLE_TO_INTERACT_MINING: 'Du hast nicht das nötige Wissen, um dieses Gestein abzubauen.',
    UNABLE_TO_INTERACT_FISHING: 'Du kannst hier im Moment nicht angeln.',
    UNABLE_TO_INTERACT_FORAGING: 'Du kannst diese Ressource im Moment nicht ernten.',

    NO_REASON_TREE: 'Es gibt keinen Grund für dich, diesen Baum zu fällen.',
    NO_REASON_FISHING: 'Es gibt keinen Grund für dich, hier zu fischen.'
} as const;
